import React from "react";
import { Button, Dropdown, ProgressBar } from "react-bootstrap";
import styles from "./ChatWorkspace.module.scss";

function formatTime(value) {
  if (!value) return "";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
}

export default function ChatSidebar({
  conversations,
  activeConversationId,
  onSelectConversation,
  onCreateConversation,
  onRenameConversation,
  onDeleteConversation,
  usage,
}) {
  return (
    <div className={styles.chatSidebar}>
      <div className={styles.sidebarHeader}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h5 className={styles.panelHeaderTitle}>Abyss</h5>
            <div className={styles.panelHeaderSubtitle}>History, models, and usage</div>
          </div>
          <Button size="sm" onClick={onCreateConversation}>
            New
          </Button>
        </div>
      </div>

      <div className={styles.usageCard}>
        <div className="fw-semibold mb-1">Usage this period</div>
        <div className="small text-muted mb-2">
          {usage?.used_tokens || 0} tokens
          {usage?.max_tokens ? ` / ${usage.max_tokens}` : ""}
        </div>
        <ProgressBar now={Math.min(100, usage?.token_percent || 0)} className="mb-2" />
        <div className="small text-muted">
          Cost: ${Number(usage?.used_cost || 0).toFixed(2)}
          {usage?.max_cost ? ` / $${Number(usage.max_cost).toFixed(2)}` : ""}
        </div>
        <ProgressBar
          now={Math.min(100, usage?.cost_percent || 0)}
          variant="info"
          className="mt-2"
        />
      </div>

      <div className={styles.sidebarBody}>
        {conversations?.length ? (
          conversations.map((conversation) => {
            const active = conversation.id === activeConversationId;
            return (
              <div
                key={conversation.id}
                className={`${styles.conversationItem} ${active ? styles.conversationActive : ""}`}
                onClick={() => onSelectConversation(conversation)}
              >
                <div className="d-flex justify-content-between align-items-start gap-2">
                  <div className="flex-grow-1">
                    <div className={styles.conversationTitle}>{conversation.title}</div>
                    <div className={styles.conversationMeta}>
                      {conversation.selected_model}
                    </div>
                    <div className={styles.conversationMeta}>
                      {formatTime(conversation.last_message_at)}
                    </div>
                  </div>
                  <Dropdown align="end" onClick={(e) => e.stopPropagation()}>
                    <Dropdown.Toggle variant="light" size="sm">
                      •••
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          const nextTitle = window.prompt("Rename chat", conversation.title);
                          if (nextTitle) onRenameConversation(conversation, nextTitle);
                        }}
                      >
                        Rename
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => {
                          if (window.confirm("Delete this chat?")) {
                            onDeleteConversation(conversation);
                          }
                        }}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-muted small">No saved chats yet.</div>
        )}
      </div>
    </div>
  );
}
